import { render, staticRenderFns } from "./UserScoreRule.vue?vue&type=template&id=2e241622&"
import script from "./UserScoreRule.vue?vue&type=script&lang=js&"
export * from "./UserScoreRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports